import React, { useState } from 'react';
import useUserSetup from './useUserSetup';
import { useNavigate } from 'react-router-dom';
import { USER_LOGOUT } from '../Utils/apis';


const useLogOut = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const setupAuth = useUserSetup();
    const Navigate = useNavigate();

    const fn = async () => {
        if (!loading) {
            
            try {
                setLoading(true)
                const res = await fetch(USER_LOGOUT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                });
                
                if (res.ok) {
                    const user = await res.json();
                    setupAuth();
                    window.sessionStorage.clear();
                    Navigate('/auth/login');
                    window.location.reload();
                }
                else {
                    const err = await res.json();
                    throw new Error(err.error);
                }
            } catch (error) {
                // setError(error.message);
                // return Promise.reject(error.message);
            }
            finally {
                setLoading(false);
            }
        }

    }
    return [loading, error, fn];
}

export default useLogOut;